import { render, staticRenderFns } from "./registerPolitic.vue?vue&type=template&id=e39d0216&"
import script from "./registerPolitic.vue?vue&type=script&lang=js&"
export * from "./registerPolitic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports